import { render, staticRenderFns } from "./detailTrip.vue?vue&type=template&id=4ece6571&scoped=true&"
import script from "./detailTrip.vue?vue&type=script&lang=js&"
export * from "./detailTrip.vue?vue&type=script&lang=js&"
import style0 from "./detailTrip.vue?vue&type=style&index=0&id=4ece6571&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ece6571",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer})
